const DEFAULT_LOCALE = 'es-ES';

/** Maps i18n language (`es`, `it`, `es-ES`, …) to BCP 47 locale for Intl APIs. */
export function resolveUiLocale(language?: string | null): string {
  if (!language) return DEFAULT_LOCALE;
  const base = language.split('-')[0]?.toLowerCase();
  if (base === 'it') return 'it-IT';
  if (base === 'es') return 'es-ES';
  return language;
}

export function formatUiDate(
  value: Date | string,
  options?: Intl.DateTimeFormatOptions,
  language?: string | null,
): string {
  const date = typeof value === 'string' ? new Date(value) : value;
  if (Number.isNaN(date.getTime())) {
    return typeof value === 'string' ? value : '';
  }
  return date.toLocaleDateString(resolveUiLocale(language), options);
}

export function formatUiNumber(
  value: number,
  options?: Intl.NumberFormatOptions,
  language?: string | null,
): string {
  return value.toLocaleString(resolveUiLocale(language), options);
}
